import firebase from "firebase";

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCJ52GJoODqMvenIHoPQ1rwODvhuuDWE0g",
    authDomain: "whatsapp-clone-e33b7.firebaseapp.com",
    projectId: "whatsapp-clone-e33b7",
    storageBucket: "whatsapp-clone-e33b7.appspot.com",
    messagingSenderId: "667102206957",
    appId: "1:667102206957:web:7378b93fe2340c73cf25e4",
    measurementId: "G-6PEENTKXD6"
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;